import React, { Component } from 'react';
import ReportHeader from '../../ReportHeader'
import ReportHeader2 from '../../ReportHeader2'
import ReportHeader3 from '../../ReportHeader3'
import Section from '../../ReportSection/index'
import { NON_ZERO_COMPLETE } from './constants'
import ErrorTable from '../ErrorTable'
import SuccessStatus from '../../SuccessStatus/index'
import T from 'i18n-react'
import styles from './styles.scss'
import CSSModules from 'helpers/CSSModulesUtil'
import {
  Table,
    TableHead,
    TableRow,
    TableCell
} from 'react-toolbox'
import { connect } from 'react-redux'
import { downloadFiles } from 'containers/Project/NvqualSection/actions'
import { compose } from 'recompose';
import CustomerInputsTable from '../../CustomerInputsTable'
import { CUSTOMER_INPUTS } from 'containers/NvqualReport/constants'

const mapDispatchToProps = (dispatch) => {
  return {
      onDownloadFile: (files, name) => dispatch(downloadFiles(files, name))
  }
}

class InputEdpPeakTest extends Component {


    renderAdditionalErrorInformation (errorType, info) {
      switch(errorType){
        case 'input_edp_detect_active':
          return (
          <React.Fragment>
              {info.rowText.map ((x, i) => {
              const containsActive = x.includes("Active") && !x.includes("Not Active")
              return <code className={containsActive ? styles.red:''} key={i}>{x}<br/></code>
            })}<br />
            <code>Workload String: "{info.workloadInfo}"</code>
          </React.Fragment>)
        case 'input_edp_non_zero_complete':
          return NON_ZERO_COMPLETE.map((x, i)  => {
            return (
              <code key={i}>
                {`${T.translate(`containers.project.nvqualSection.errors.inputEdpNonZeroComplete.${x}`)}: ${info[x]}`}<br/>
              </code>
                )
        })
      }
    }

    customerInputsPrep(customerInputs) {
      const { testId } = this.props
      CUSTOMER_INPUTS[testId].forEach(x => {
        if (!customerInputs[x]) return
        switch (x) {
          case 'inputVoltage54V':
            const val = customerInputs[x].value
            if (!val) return
            const min = val[0] ? val[0] : "Unknown"
            const max = val[1] ? val[1] : "Unknown"
            customerInputs[x].value = `Minimum = ${min}; Maximum = ${max}`
        }
      })
      return customerInputs
    }

    renderResultTable() {
      const { data } = this.props
      return (
        <Table selectable={false}>
          <TableHead key={`head`}>
            <TableCell key={`clocks`}>Current Application Clocks</TableCell>
            <TableCell key={`workload`}>Workload String</TableCell>
            <TableCell key={`statusNum`}>Status #</TableCell>
            <TableCell key={`passFail`}>Pass/Fail</TableCell>
          </TableHead>
          {data.map((row, idx) => (
            <TableRow key={idx}>
              <TableCell key={`clocks${idx}`}>{row.applicationClocks}</TableCell>
              <TableCell key={`workload${idx}`}><code>{row.workload}</code></TableCell>
              <TableCell key={`statusNum${idx}`}>{row.completeNum}</TableCell>
              <TableCell key={`passFail${idx}`}><code className={row.pass == 'Pass' ? styles.green : styles.red}>{row.pass}</code></TableCell>
            </TableRow>
          ))}
        </Table>
      )
    }

    render(){
        const { data, error, onDownloadFile, files, testName, customerInputs, testId, result } = this.props
        const hasErrorData = error && error.length > 0
        const fileIds = files ? files.map((f) => f.id) : []

        return(
        <Section>
            <ReportHeader
             title={T.translate(`containers.project.nvqualSection.test.${testId}`)}
             showDownload
             onDownloadClick={onDownloadFile.bind(this, fileIds, testName)}/>
            <Section>
              {data && 
                <React.Fragment>
                  <ReportHeader2 title={'Summary'} />
                  <SuccessStatus result={result} />
                  </React.Fragment>}
              {hasErrorData && 
                <React.Fragment>
                <ReportHeader3 title={'Errors'} />
                    <ErrorTable
                        errors={error}
                        errorSpecificRenderFunc={this.renderAdditionalErrorInformation} />
                </React.Fragment>}
            </Section>
            {customerInputs && 
              <CustomerInputsTable
                showComments
                title={'Customer Inputs'}
                customerInputs={this.customerInputsPrep(customerInputs)}
                section={testId}/>}
            {data && 
              <Section>
                  <ReportHeader2 title={'Test Results'} />
                  {this.renderResultTable()}
              </Section>}
        </Section>
        );
    }
    }

    const withConnect = connect(null, mapDispatchToProps)
    const withStyles = CSSModules(styles);
    const enhance = compose(withConnect, withStyles);
    export default enhance(InputEdpPeakTest);
